import { linkToClassPage } from "../../links";

export function linkToClassCoursesPage(classId?: string) {
  return `${linkToClassPage(classId)}/courses`;
}
